import PropTypes from 'prop-types';
import {Component} from 'react';
import {Confirm} from 'semantic-ui-react';
import TestimonialEdit from './TestimonialEdit';
import TestimonialView from './TestimonialView';

export default class Testimonial extends Component {
  static propTypes = {
    testimonial: PropTypes.object.isRequired,
    update: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      edit: props.testimonial.editing,
      open: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.testimonial !== this.props.testimonial) {
      this.setState({edit: this.props.testimonial.editing});
    }
  }

  toggleEdit = () => {
    this.setState({edit: !this.state.edit});
    this.props.testimonial.editing = !this.props.testimonial.editing;
  };

  update = (testimonial) => {
    const {update} = this.props;
    this.props.testimonial.editing = false;
    update(testimonial);
    this.toggleEdit();
  };

  showConfirmationDialog = (show) => {
    return () => {
      this.setState({open: show});
    };
  };

  onConfirm = () => {
    const {remove, testimonial} = this.props;

    remove(testimonial);
    this.showConfirmationDialog(false)();
  };

  render() {
    const {edit} = this.state;
    const {testimonial} = this.props;
    return (
      <div>
        {edit ?
          <TestimonialEdit testimonial={testimonial} save={this.update} remove={this.showConfirmationDialog(true)}/>
          : <TestimonialView testimonial={testimonial} edit={this.toggleEdit}
                             remove={this.showConfirmationDialog(true)}/>}

        <Confirm className="confirm-delete" open={this.state.open} onCancel={this.showConfirmationDialog(false)}
                 onConfirm={this.onConfirm} size="tiny"
                 confirmButton="Delete" content="Are you sure you want to delete this testimonial?"/>
      </div>
    );
  }
}
